import { Fragment } from 'vue';

export function normalizeSlotChildren(children) {
    if (typeof children === 'function') {
        return children();
    }

    if (Array.isArray(children)) {
        return children;
    }

    if (children?.default) {
        return typeof children.default === 'function'
            ? children.default()
            : children.default;
    }

    return children ? [children] : [];
}

export function flattenSlotChildren(children) {
    return normalizeSlotChildren(children).flatMap(child => {
        if (!child) {
            return [];
        }

        if (Array.isArray(child)) {
            return flattenSlotChildren(child);
        }

        if (child.type === Fragment && Array.isArray(child.children)) {
            return flattenSlotChildren(child.children);
        }

        return [child];
    });
}

export function getRenderableSlotChildren(children) {
    const renderableTypes = ['string', 'object', 'function'];
    return flattenSlotChildren(children).filter(child => renderableTypes.includes(typeof child.type));
}